import { produce } from 'immer'
import {
  closeBillPayCardRouteProps,
  closeVirtualCardRouteProps,
} from 'src/navigation/routeProps'
import {
  PUT_CLOSE_VIRTUAL_CARD_FAILURE,
  PUT_CLOSE_VIRTUAL_CARD_INIT,
  PUT_CLOSE_VIRTUAL_CARD_SUCCESS,
  PutCloseVirtualCardActions,
} from 'src/redux/actions/data/virtualCards.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import { parseBackendErrors } from 'src/utils/error.utils'

export interface CloseVirtualCardContentState {
  puttingCloseVirtualCard: boolean
  topLevelError?: string
}

export const initialState: CloseVirtualCardContentState = {
  puttingCloseVirtualCard: false,
}

export type Actions = PutCloseVirtualCardActions

const CoreCloseVirtualCardReducer = (
  state = initialState,
  action: Actions,
): CloseVirtualCardContentState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case PUT_CLOSE_VIRTUAL_CARD_INIT: {
        draft.puttingCloseVirtualCard = true
        draft.topLevelError = undefined
        return draft
      }

      case PUT_CLOSE_VIRTUAL_CARD_FAILURE: {
        draft.puttingCloseVirtualCard = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        return draft
      }

      case PUT_CLOSE_VIRTUAL_CARD_SUCCESS: {
        draft.puttingCloseVirtualCard = false
        return draft
      }
    }
  })
}

const CloseVirtualCardContentReducer = createFlyoutReducer(
  [closeVirtualCardRouteProps, closeBillPayCardRouteProps],
  initialState,
  CoreCloseVirtualCardReducer,
)

export default CloseVirtualCardContentReducer
